module.exports = __webpack_public_path__ + "static/media/car-1.a3678656.jpg";